import gql from 'graphql-tag';

export const SUBSCRIBE_TO_NEWSLETTER = gql`
	mutation SubscribeToNewsletter($input: SubscriptionInput!) {
		subscribeToNewsletter(input: $input)
	}
`;
